import * as React from "react";
import { getDirectionsUrl } from "../../helpers/location";
import Text from "../common/input/text";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import Rating, { RatingCount, Stars } from '../common/Rating';
import { formatPhoneNumber, getFirstName, firstNameFirst } from "../../helpers/formatting";
import moment from 'moment-timezone';
const reasonForRevisitId = 'reasonForRevisit';
const DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD';
const DATE_FORMAT = Tools.getDateFormats();

export default class ReasonForVisit extends React.Component {
    constructor(props, context) {
        super(props, context);
        const maxLength = 250;
        this.state = {
            visitReason: props.visit && props.visit.reasonForVisit,
            minLengthOfVisitReason: 2,
            maxLengthOfVisitReason: maxLength,
            chars_left: maxLength,
            createPatientDOB: '',
            createPatientGender: '',
            nationalIdentifier: '',
            patientPhone: '',
            insuranceName: '',
            notListedInsuranceName: '',
            memberId: '',
            subscriberId: '',
            groupNumber: '',
            mailingAddress: null
        };
        this.is_Validated = this.is_Validated.bind(this);
        this.createPatient = this.createPatient.bind(this);
        this.formatTime = this.formatTime.bind(this);
        this.stupidDatePickerHack = this.stupidDatePickerHack.bind(this);
        this.reasonForVisitInput = React.createRef();
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ReasonForVisit.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    onGoNext(success) {
        if (success) {
            const visit = this.props.visit;
            visit.reasonForVisit = this.state.visitReason;
            const date = moment(visit.date).format(DATE_FORMAT_YYYY_MM_DD);
            visit.date = date;
            this.props.saveStepInfo({ visit: visit });
            if (this.props.onSubmit) {
                this.props.onSubmit();
            }
        }
        else {
            this.setState({ showAsInvalid: true });
        }
    }

    isValid() {
        const valid = typeof this.state.visitReason !== "undefined" && this.state.visitReason !== null && this.state.visitReason !== "" && this.state.visitReason.length >= this.state.minLengthOfVisitReason;
        if (!valid) { //Fixed Bug 34195: Scheduling: Reason for Visit - Text and input are automatically red
            //this.refs.reason4Visit.validateOnBlur();
            this.refs.reason4Visit.refs.actualTextArea.focus();
        }
        return valid;
    }

    //if the patient has filled in enough fields on the form, he/she is allowed to save the dater.
    is_Validated() {
        if (this.isValid()) {
            try {
                const address = this.props.selectedDepartmentId && this.props.departments ? this.props.departments.find((item) => item.value === this.props.selectedDepartmentId) : undefined;
                const visit = this.props.visit;
                visit.reasonForVisit = this.state.visitReason;
                this.props.saveStepInfo({ visit: visit });
                this.setState({ showAsInvalid: false });
                return true;
            }
            catch { return false; }
        }
        else {
            const input = document.getElementById(reasonForRevisitId);
            if (input) {
                input.focus();
            }
            this.setState({ showAsInvalid: true });
            return false;
        }
    }

    handleInputChange(e) {
        if (e) {
            const target = e.target;
            const charCount = target.value.length;
            const charLeft = this.state.maxLengthOfVisitReason - charCount;
            this.setState({ visitReason: target.value, chars_left: charLeft },
                () => {
                    const valid = this.isValid();
                    if (this.valid !== valid) {
                        this.valid = valid;
                        if (this.props.isValid) {
                            this.props.isValid(valid);
                        }
                    }
                }
            );
        }
    }

    redirectToMap(item) {
        if (item.Address) {
            const toAddress = item.Address.locationStreet1 + ', ' + item.Address.locationCity + ', ' + item.Address.locationState + ' ' + item.Address.locationZip;
            var addressUrl = getDirectionsUrl(null, toAddress);
            if (typeof window !== 'undefined' && addressUrl) {
                window.open(addressUrl, "_blank");
            }
        }
    }


    getDayOfWeek(x) {
        //debugger;
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
        var weekday = new Array(7);
        weekday[0] = "SUN";
        weekday[1] = "MON";
        weekday[2] = "TUE";
        weekday[3] = "WED";
        weekday[4] = "THU";
        weekday[5] = "FRI";
        weekday[6] = "SAT";
        if (Object.prototype.toString.call(dt) === '[object Date]') {
            var strDay = weekday[dt.getDay()];
            return strDay;
        }
        return "Invalid Date";
    }

    date2str(x) {
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
        const dayName = dt.getDate();
        let monthName = dt.getMonth() + 1;
        if (monthName < 10)
            monthName = "0" + monthName;
        const yearName = dt.getFullYear().toString();
        return `${Tools.getMonthName(monthName.toString())} ${dayName} , ${yearName}`;
    }

    formatTime(s) {
        let parts = s.split(":");
        let ret = s;

        if (parts.length >= 2) {
            let h = parseInt(parts[0]);
            let m = parseInt(parts[1]);
            let s = parseInt(parts[2]);

            let ispm = h >= 12;
            h = h > 12 ? h - 12 : h;

            ret = `${h.toString()}:${m.toString().padStart(2, '0')} ${ispm ? "PM" : "AM"}`;
        }

        return ret;
    }

    stupidDatePickerHack(dt) {
        // turn a string containing YYYY-MM-DD into one containing MM/DD/YYYY
        let parts = dt.split('-');
        return parts && parts.length > 1 ? `${parts[1].toString().padStart(2, "0")}/${parts[2].toString().padStart(2, "0")}/${parts[0]}` : null;
    }

    createPatient() {
        var model = {
            email: this.props.userDetails.Email,
            firstName: this.props.userDetails.Givenname,
            lastName: this.props.userDetails.Surname,
            dateOfBirth: this.state.createPatientDOB,
            gender: this.state.createPatientGender,
            nationalIdentifier: this.state.nationalIdentifier,
            patientPhone: this.state.patientPhone.replace(/\./ig, ''),
            mailingAddress: this.state.mailingAddress
        };

        if (this.state.insuranceName !== "") {
            model.insurance = {
                insuranceName: this.state.notListedInsuranceName === '' ? this.state.insuranceName : this.state.notListedInsuranceName,
                memberId: this.state.memberId,
                subscriberId: this.state.subscriberId,
                groupNumber: this.state.groupNumber
            };
        }

        this.props.createPatient(model);
    }

    render() {
        const { nonMyChartPatientDetails, serverData } = this.props;
        const visit = this.props.visit;
        const primaryUser = this.props.primaryUser;
        const selectedDepartmentId = this.props.visit?.department?.id ?  this.props.visit.department.id : "";
        const address = selectedDepartmentId && this.props.departments ? this.props.departments.find((item) => item.value.indexOf(selectedDepartmentId) >= 0) : undefined;
        const providerDetails = this.props.providerDetails;

        // As discussed, we need to disable location for all visits present in VideoVisitTypesForLaunchButton config.
        const videoVisitTypesForLaunchButton = serverData && serverData.videoVisitTypesForLaunchButton && serverData.videoVisitTypesForLaunchButton.length > 0 ? serverData.videoVisitTypesForLaunchButton : null;
        let disableLocationForVisits = videoVisitTypesForLaunchButton ? videoVisitTypesForLaunchButton + "," : null;
        const videoVisitTypesForDirectScheduling = serverData && serverData.enableCustomDirectScheduling && disableLocationForVisits ? disableLocationForVisits.split(',') : null;
        const isVirtualCareVisit = videoVisitTypesForDirectScheduling ? visit && visit.visitType && visit.visitType.id && videoVisitTypesForDirectScheduling.indexOf(visit.visitType.id) >= 0 ? true : false : false;
        const prov = {
            photo: this.props.provider ? this.props.provider.photoUrl : '',
            averageRatingStr: this.props.provider ? this.props.provider.averageRating : 0,
            reviewCountStr: this.props.provider ? this.props.provider.ratingCount : 0,
            displayName: this.props.provider ? this.props.provider.displayName : "",               // Jason: you can just populate this from props; also look at care/FindCareResults for how to use StarRatings, etc.
            specialty: this.props.provider ? this.props.provider.specialty : "",
            Address: {
                locationStreet1: address ? address.address1 : "",
                locationStreet2: address ? address.address2 : "",
                locationCity: address ? address.city : "",
                locationState: address ? address.state : "",
                locationZip: address ? address.zip : ""
            }
        };

        const defaultPhone = providerDetails && providerDetails.consumerCallCenterNumber ? providerDetails.consumerCallCenterNumber : (visit.department ? visit.department.phone : "");
        let appendVisit = visit.visitType?.description?.toLowerCase().indexOf("visit") >= 0 ? "" : " Visit";
        const appt = {
            visitType:  visit.visitType?.description && visit.visitType?.description + appendVisit,
            TimeString: visit.time && this.formatTime(visit.time),
            DayString: visit.date && this.getDayOfWeek(visit.date),
            DateString: this.date2str(visit.date)
        };
        const patient = {
            name: (visit.patient && visit.patient.name) ? visit.patient.name : (primaryUser && primaryUser.displayName ? primaryUser.displayName : ""),
            Address: {
                locationStreet1: visit.patient ? visit.patient.street1 : '',
                locationCity: visit.patient ? visit.patient.city : '',
                locationState: visit.patient ? visit.patient.state : '',
                locationZip: visit.patient ? visit.patient.zip : ''
            },
            email: visit.patient ? visit.patient.email : '',
            phone: visit.patient ? visit.patient.phoneNumber : ''
        };

        const provPhoto = prov.photo ? prov.photo : '/images/profile-pic.png';

        let insurancePlans = [...this.props.insurancePlans];
        insurancePlans.push({ key: insurancePlans.length, value: "Not Listed", label: "Not Listed" });
        insurancePlans.push({ key: insurancePlans.length, value: "No Insurance", label: "No Insurance" });

        return (

            <div className="schedule-visit-reason-container" style={this.props.style}>
                <div className="row">
                    <div className="col-12">
                        {/*this.props.currentUser !== null ?
                           <h1 className="step-heading">Why {this.props.scheduleAppointmentForProxy ? this.props.primaryUser.eid === this.props.currentUser.eid ? ' are you ' : 'is ' + getFirstName(this.props.currentUser.displayName) : ' are you '} coming in for a visit?</h1> :
                           <h1 className="step-heading">We need a little more information.</h1>
                           */
                        }
                        {
                            this.props.currentUser !== null ?
                                <h1 className="step-heading">What can we help {this.props.scheduleAppointmentForProxy ? this.props.primaryUser.eid === this.props.currentUser.eid ? 'you' : getFirstName(this.props.currentUser.displayName) : 'you'} with during this visit?</h1> :
                                <h1 className="step-heading">We need a little more information.</h1>
                        }
                    </div>
                </div>
                <div className="row confirm-appt-details-container">

                    <div className="col-12 col-lg-6 form-group">
                        <Text name="visitReason" placeholder="Enter comments"
                            id={reasonForRevisitId} value={this.state.visitReason} required
                            maxSize={this.state.maxLengthOfVisitReason}
                            onChange={(e) => this.handleInputChange(e)}
                            showAsInvalid={!this.valid && this.state.showAsInvalid}
                            ref="reason4Visit"
                            rows="10"
                            autoFocus
                        />
                        <div className={this.state.chars_left === 0 ? "hint-text warning" : "hint-text"}>{this.state.chars_left} - Characters Remaining </div>
                    </div>
                    <div className="col-12 col-lg-6 confirm-addl-details">
                        {/* START VISIT DETAILS */}
                        <div className="confirm-visit-details">
                            <span className="icon-calendar-form" />
                            <span className="visit-time">{appt.DayString} {appt.DateString} - {appt.TimeString}</span>
                        </div>
                        <div className="visit-type">{appt.visitType} </div>
                        {/* END VISIT DETAILS */}

                        {/* START DOCTOR DETAILS */}
                        <div className="col-12 confirm-dr-details">
                            <div className="item-avatar-container">
                                <div className="item-img-container" style={{ backgroundImage: `url(${provPhoto})` }} >
                                    <div className="item-img" />
                                </div>
                                {(prov.averageRatingStr && prov.averageRatingStr !== "" && prov.averageRatingStr !== '0') &&
                                    <Rating align="bottom" isRatingCount isAverageRatingCount reviewCount={prov.reviewCountStr} starDimension="12px" averageRating={prov.averageRatingStr}>
                                        <Stars />
                                        <RatingCount />
                                    </Rating>
                                }
                            </div>
                            <div className="item-details">
                                <div className="row">
                                    <div className="col-12 item-name">
                                        {prov.displayName}<br />
                                        <span className="item-specialty">{prov.specialty}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 item-location">
                                        <a tabIndex="0" className={prov.Address ? "directions-link" : "no-link"} onClick={() => this.redirectToMap(prov)}>
                                            <div className="details-icon-prepend">
                                                <div className="icon-col">
                                                    <span className="icon-address" />
                                                </div>
                                                <div className="details-col">
                                                    {prov.Address ?
                                                        <div>
                                                            <div>{prov.Address.locationStreet1}{prov.Address.locationStreet2 && <span>, {prov.Address.locationStreet2},</span>} </div>
                                                            <div>{prov.Address.locationCity}, {prov.Address.locationState} {prov.Address.locationZip} </div>
                                                        </div>
                                                        : <div className="no-data-dash">
                                                            <div />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 item-phone">
                                        <a className={defaultPhone ? "phone-link" : "no-link"} href={defaultPhone ? "tel:" + (defaultPhone) : "#"}>
                                            <div className="details-icon-prepend">
                                                <div className="icon-col">
                                                    <span className="icon-phone" />
                                                </div>
                                                <div className="details-col">
                                                    {defaultPhone ?
                                                        <div>{defaultPhone}</div>
                                                        : <div className="no-data-dash">
                                                            <div />
                                                        </div>}
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* END DOCTOR DETAILS */}
                    </div>
                </div>

                {/* START PRESS GANEY LEGAL */}
                <div className="row schedule-provider-legal">
                    <div className="col-12">
                        <div className="rating-footnote">
                            * The patient rating score is an average of all responses to physician-related questions on our nationally recognized&nbsp;
                            <a tabIndex="-1" href="https://www.bswhealth.com/physicians/about-press-ganey-satisfaction-survey" target="_blank">Press Ganey Satisfaction Survey</a>.
                        </div>
                    </div>
                </div>
                {/* END PRESS GANEY LEGAL */}
                <div className="row schedule-provider-info">
                    <div className="col-12">
                        <span className="icon-info-filled"></span>
                        <div className="info-message">
                            Prior to your appointment, please contact your insurance carrier to understand facility and provider network status and benefit coverage for your specific insurance plan.
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}